// extracted by mini-css-extract-plugin
module.exports = {"ageGateButton":"style_ageGateButton__22acK"};